import { InventoryFilter } from '../shared/inventory-filter.model';
import * as inventoryActions from './inventory.actions';

export interface InventoryState {
  summary: {
    showing: string;
    filter: InventoryFilter;
    invSumSelectedRow: any;
  };
  detail: {
    showing: string;
    invDtlSelectedRow: any;
  };
  lot: {
    showing: string;
  };
  lotrequired: {
    lotrequired: any[];
  }
}

export const initialState: InventoryState = {
  summary: {
    showing: 'grid',
    filter: null,
    invSumSelectedRow: null,
  },
  detail: {
    showing: inventoryActions.InvDtlShowing.grid,
    invDtlSelectedRow: null,
  },
  lot: {
    showing: inventoryActions.InvLotShowing.grid,
  },
  lotrequired: {
    lotrequired: null,
  }
};

export function inventoryReducer(state = initialState, action: inventoryActions.InventoryActions) {
  switch (action.type) {
    case inventoryActions.INV_SUM_INIT:
      return initialState;
    case inventoryActions.INV_SUM_SET_FILTER:
      return {
        ...state,
        summary: {
          ...state.summary,
          filter: action.filter,
        },
      };
    case inventoryActions.INV_SUM_CLEAR_FILTER:
      return {
        ...state,
        summary: {
          ...state.summary,
          filter: null,
        },
      };
    case inventoryActions.INV_SUM_SET_SHOWING:
      return {
        ...state,
        summary: {
          ...state.summary,
          showing: action.area,
        },
      };
    case inventoryActions.INV_SUM_SELECT_ROW:
      return {
        ...state,
        summary: {
          ...state.summary,
          invSumSelectedRow: action.row,
        },
      };
    case inventoryActions.INV_SUM_CLEAR_SELECT_ROW:
    case inventoryActions.INV_SUM_REQUEST_DATA:
      return {
        ...state,
        summary: {
          ...state.summary,
          invSumSelectedRow: null,
        },
      };
    case inventoryActions.INV_DTL_INIT:
      return {
        ...state,
        detail: {
          ...state.detail,
          showing: 'grid',
        },
      };
    case inventoryActions.INV_DTL_SET_SHOWING:
      return {
        ...state,
        detail: {
          ...state.detail,
          showing: action.area,
        },
      };
    case inventoryActions.INV_DTL_SELECT_ROW:
      return {
        ...state,
        detail: {
          ...state.detail,
          invDtlSelectedRow: action.row,
        },
      };
    case inventoryActions.INV_DTL_CLEAR_SELECT_ROW:
    case inventoryActions.INV_DTL_REQUEST_DATA:
      return {
        ...state,
        detail: {
          ...state.detail,
          invDtlSelectedRow: null,
        },
      };
    case inventoryActions.INV_LOT_INIT:
      return {
        ...state,
        lot: {
          ...state.lot,
          showing: 'grid',
        },
      };
    case inventoryActions.INV_LOT_SET_SHOWING:
      return {
        ...state,
        lot: {
          ...state.lot,
          showing: action.area,
        },
      };
    case inventoryActions.INV_LOT_REQUEST_DATA:
      return {
        ...state,
        lot: {
          ...state.lot,
          invLotSelectedRow: null,
        },
      };

    case inventoryActions.INV_ITEM_LOT_REQ_DATA_SUCESS:
      return {
        ...state,
        lotrequired: {
          ...state.lotrequired,
          lotrequired: action.lotrequiredItem,
        },
      };
    default:
      return state;
  }
}
